// extracted by mini-css-extract-plugin
export default {"wrapper":"CsujIvpR","h1":"wyR14Nmx","h2":"Jvo_M7rL","h3":"NmcOQkbS","h4":"elK2_dv3","subtitle1":"dWknBaWD","subtitle2":"qLn4vail","body1":"nE6bi2qj"};